$(document).ready(function(){
	$('#call_to_action_registration_close_button').click(function() {
	  $('#call_to_action_registration_main_container').css('display', 'none');
	});
}); 